var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustom4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FD982C"
    },
    points: "446.149,420.109 446.149,178.826 255.989,112.915 65.829,178.826 65.829,420.109  255.989,480.421 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FA502E"
    },
    points: "446.149,420.109 446.149,178.826 255.989,112.915 255.989,480.421 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFF2B4"
    },
    points: "446.149,178.826 255.989,112.915 65.829,178.826 255.989,245.736 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDF8E"
    },
    points: "446.149,178.826 255.989,112.915 255.989,245.736 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FABE3D"
    },
    points: "65.829,178.826 0,256.722 193.739,327.127 255.989,245.736  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FABE3D"
    },
    points: "446.149,178.826 512,256.722 318.261,327.127 255.989,245.736  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FD982C"
    },
    points: "446.149,178.826 512,256.722 318.261,327.127 255.989,245.736 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDDA50"
    },
    points: "65.829,178.826 0,101.985 193.739,31.579 255.989,112.915 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FABE3D"
    },
    points: "446.149,178.826 512,101.985 318.261,31.579 255.989,112.915 "
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustom4);
export default __webpack_public_path__ + "static/media/custom_4.a57e189ce0b442756fb04dc4b415fe3f.svg";
export { ForwardRef as ReactComponent };